import {
  Link,
  Image
} from '@chakra-ui/react'
import React from 'react'


export default function Logo() {
  return(
    <Link href={'/'}>
   <Image
    alt={'Marketocracy Logo'}
    maxH={{
      base: '60px',
      sm: '35px',
      lg: '75px',
    }} 
    src={
      'https://marketocracy-io.s3.us-east-2.amazonaws.com/logo/mkyio-logo.png'
    }
  />
</Link>
  )
}